import { useApiClient } from "../../api-client";

export const useUpdateTermsAndConditions = () => {
  const { post } = useApiClient();

  const updateTermsAndConditions = () =>
    post("/v1/employees/terms-and-conditions/accept");

  return {
    updateTermsAndConditions,
  };
};
